// Entrypoint for js-bundling: register Popper as global Var

import Popper from 'popper.js';
globalThis.Popper = Popper;
